<template>
  <div class="submit_dialog">
    <el-dialog :visible.sync="dialogVisible" width="840px">
      <h1>免费提供咨询</h1>
      <h2>提交咨询信息后工作人员会与您取得联系，请保持通话畅通。</h2>
      <el-form
        label-position="left"
        ref="form"
        :model="form"
        label-width="100px"
      >
        <el-form-item label="我想了解" :error="smsError.business">
          <el-radio-group v-model="form.business">
            <el-radio label="safe_qualification">资质安全</el-radio>
            <el-radio label="safe_content">内容安全</el-radio>
            <el-radio label="cms_platform">审核平台</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="联系人姓名" :error="smsError.contact_name">
          <el-input
            v-model="form.contact_name"
            placeholder="请输入联系人姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号码" :error="smsError.phone">
          <el-input
            v-model="form.phone"
            placeholder="请输入手机号码"
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码" :error="smsError.code">
          <el-input
            v-model="form.code"
            placeholder="请输入短信验证码"
          ></el-input>
          <el-button
            type="primary"
            @click="sendVerifyCode"
            class="submit_dialog_send_btn"
            v-if="showSendBtn"
          >
            发送验证码
          </el-button>
          <el-button type="primary" class="submit_dialog_send_btn" v-else>
            {{ countDown }} 秒
          </el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="submit_dialog_footer">
        <el-button @click="resetDialog">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" class="submit_btn">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Axios from 'axios'
import { SERVER_API } from '@/config'
const formInit = {
  business: '',
  contact_name: '',
  phone: '',
  code: '',
}
const smsErrorInit = {
  business: '',
  contact_name: '',
  phone: '',
  code: '',
}
export default {
  data() {
    return {
      dialogVisible: false,
      form: { ...formInit },
      countDown: 60,
      showSendBtn: true,
      countDownSet: '',
      smsError: {
        ...smsErrorInit,
      },
    }
  },

  computed: {
    axios() {
      return Axios.create({
        baseURL: SERVER_API,
        timeout: 1000 * 180, // 20sec
      })
    },
  },

  watch: {
    countDown(newValue) {
      if (newValue <= 0) {
        clearInterval(this.countDownSet)
        this.countDown = 60
        this.showSendBtn = true
      }
    },
  },

  methods: {
    getTencentCaptch() {
      return new Promise((resolve, reject) => {
        const cap = new window.TencentCaptcha('2072676418', (res) => {
          if (res.ret === 0) {
            resolve(res)
          } else {
            reject(res)
          }
        })
        cap.show()
      })
    },

    async sendVerifyCode() {
      const captchResult = await this.getTencentCaptch()

      if (!captchResult) {
        return Promise.reject()
      }

      this.smsError.phone = ''

      this.axios
        .post('/sms/code/', {
          phone: this.form.phone,
          qq_captcha: `${captchResult.ticket};${captchResult.randstr}`,
        })
        .then(() => {
          this.showSendBtn = false
          this.countDownSet = setInterval(() => {
            this.countDown -= 1
          }, 1000)
        })
        .catch((error) => {
          const errorInfo = error.response.data
          if (errorInfo) {
            if (errorInfo.non_field_errors) {
              this.$message.info(String(errorInfo.non_field_errors))
            }
            Object.keys(errorInfo).forEach((item) => {
              if (Array.isArray(errorInfo[item])) {
                this.smsError[item] = errorInfo[item][0]
              } else {
                this.smsError[item] = errorInfo[item]
              }
            })
          }
        })
    },

    resetDialog() {
      this.countDown = -1
      this.form = { ...formInit }
      this.dialogVisible = false
    },

    handleSubmit() {
      this.smsError = { ...smsErrorInit }
      this.axios
        .post('/salesource/create/', { ...this.form })
        .then(() => {
          this.$message.success(
            '恭喜您提交成功！工作人员会在3个工作日内与您联系'
          )
          this.resetDialog()
        })
        .catch((error) => {
          const errorInfo = error.response.data
          if (errorInfo.non_field_errors) {
            this.$message.info(String(errorInfo.non_field_errors))
          }
          Object.keys(errorInfo).forEach((item) => {
            if (Array.isArray(errorInfo[item])) {
              this.smsError[item] = errorInfo[item][0]
            } else {
              this.smsError[item] = errorInfo[item]
            }
          })
        })
    },
  },
}
</script>

<style lang="scss">
.submit_dialog {
  .el-icon-close {
    font-size: 20px;
  }
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 0;
  }
  .el-dialog__footer {
    padding: 0;
    display: flex;
    justify-content: center;
  }
  .el-form-item {
    display: flex;
    justify-content: center;
    align-items: center;
    .el-form-item__content {
      width: 400px;
      margin-left: 0 !important;
      text-align: left;
      display: flex;
    }
    .el-form-item__label {
      font-size: 16px;
      color: #333333;
    }
    .el-radio__label {
      font-size: 16px;
      color: #333333;
    }
    .el-input__inner {
      border: 1px solid #c9c9c9;
    }
  }
  .el-dialog__body {
    h1 {
      font-size: 24px;
      padding-top: 64px;
    }
    h2 {
      font-size: 16px;
      color: #666;
      margin-top: 46px;
      margin-bottom: 22px;
    }
  }
  .submit_dialog_send_btn {
    width: 112px;
    height: 40px;
    font-size: 16px;
    margin-left: 8px;
    padding: 0;
    flex: none;
  }
  .submit_dialog_footer {
    margin-top: 24px;
    margin-bottom: 64px;
    .submit_btn {
      margin-left: 32px;
    }
    .el-button {
      width: 120px;
      height: 48px;
      font-size: 18px;
    }
  }
}
</style>
